<template>
  <div>
    <upload
      :headers="headers"
      :action="url"
      :accept="accept"
      :format="format"
      :multiple="true"
      :show-upload-list="false"
      :before-upload="before_upload"
      :on-success="on_success"
      type="drag"
      class="dnd-uploader"
      v-on="$listeners"
    >
      <div class="dnd-uploader__drop-zone">
        <div v-if="loading" class="drop-zone__loader">
          <spin size="large" />
        </div>

        <icon v-if="!loading" type="ios-cloud-upload" size="52" class="drop-zone__icon" />

        <p class="text-center text-muted">{{ $t('shared.component.file_upload.drag') }}</p>
      </div>
    </upload>
    <p class="small text-muted mb-2 mt-2">
      {{ $t('shared.component.file_upload.format') }}: {{ format_user }}
    </p>
    <p class="small text-muted">
      {{ $t('shared.component.file_upload.weight') }}
    </p>
  </div>
</template>

<script>
  import { getBaseURL } from '@shared/helpers/url';

  const formats = ['mp3', 'wav'];

  export default {
    data: () => ({
      accept: formats.map((i) => `.${i}`).join(','),
      format_user: formats.map((i) => `.${i}`).join(', '),
      format: formats,
      loading: false
    }),
    computed: {
      url: function () {
        const campaign_id = this.$route.params.id;
        return getBaseURL(`/api/v2/informer/campaigns/${campaign_id}/mediafiles`)
      },
      headers: function () {
        return {
          Authorization: `Bearer ${this.$store.getters['core/auth/token']}`
        };
      }
    },
    methods: {
      before_upload: function () {
        this.loading = true;
      },

      on_success: function (e) {
        this.loading = false;
        this.$emit('on-success', e);
      }
    }
  };
</script>

<style lang="scss">
  .dnd-uploader {
    &__drop-zone {
      padding: 20px 0;

      .text-center {
        margin: 0 5px;
      }
    }
  }

  .drop-zone__loader {
    height: 52px;
    width: 52px;
    margin: 0 auto;
  }

  .drop-zone__icon {
    color: $primary;
  }
</style>
